import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { FaArrowRight, FaGlobe, FaApple, FaAndroid } from 'react-icons/fa';
import './Projects.css';

const colors = ['#6c5ce7', '#00cec9', '#fd79a8', '#fdcb6e', '#a29bfe', '#55efc4', '#74b9ff'];

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/projects.php')
      .then((res) => res.json())
      .then((data) => {
        setProjects(Array.isArray(data) ? data : []);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <main className="page-projects">
      <Helmet>
        <title>Nos Réalisations - Sites Web & Applications Mobiles | AGKG Créations</title>
        <meta name="description" content="Découvrez nos réalisations : sites vitrines, boutiques e-commerce, applications web et mobiles développés sur mesure pour nos clients à Béziers, Montpellier et en France." />
        <link rel="canonical" href="https://agkgcreations.fr/projets" />
        <meta property="og:title" content="Nos Réalisations | AGKG Créations" />
        <meta property="og:description" content="Portfolio de sites web et applications mobiles réalisés sur mesure par AGKG Créations." />
        <meta property="og:url" content="https://agkgcreations.fr/projets" />
      </Helmet>

      <section className="page-hero">
        <div className="container">
          <h1 className="section-title">
            Nos <span>réalisations</span>
          </h1>
          <p className="section-subtitle">
            Découvrez une sélection de projets réalisés pour nos clients
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {loading ? (
            <p style={{ textAlign: 'center', color: '#94a3b8' }}>Chargement...</p>
          ) : (
            <div className="projects-grid">
              {projects.map((project, index) => {
                const techs = typeof project.technologies === 'string'
                  ? JSON.parse(project.technologies)
                  : (project.technologies || []);
                const color = colors[index % colors.length];

                return (
                  <div key={project.id} className="project-card">
                    <div
                      className="project-image"
                      style={{ background: `linear-gradient(135deg, ${color}33, ${color}11)` }}
                    >
                      {project.image_url && (
                        <img
                          src={project.image_url}
                          alt={`${project.name} - ${project.category} réalisé par AGKG Créations`}
                          loading="lazy"
                          className="project-img"
                        />
                      )}
                      <span className="project-category">{project.category}</span>
                    </div>
                    <div className="project-info">
                      <h3>{project.name}</h3>
                      <p>{project.description}</p>
                      <div className="project-techs">
                        {techs.map((tech, i) => (
                          <span key={i} className="tech-badge">{tech}</span>
                        ))}
                      </div>
                      {(project.link || project.ios_link || project.android_link) && (
                        <div className="project-links">
                          {project.link && (
                            <a href={project.link} target="_blank" rel="noopener noreferrer" className="project-link">
                              <FaGlobe /> Voir le site
                            </a>
                          )}
                          {project.ios_link && (
                            <a href={project.ios_link} target="_blank" rel="noopener noreferrer" className="project-link project-link-ios">
                              <FaApple /> App Store
                            </a>
                          )}
                          {project.android_link && (
                            <a href={project.android_link} target="_blank" rel="noopener noreferrer" className="project-link project-link-android">
                              <FaAndroid /> Google Play
                            </a>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          <div className="projects-cta">
            <p>Vous avez un projet similaire ?</p>
            <Link to="/contact" className="btn btn-primary">
              Discutons-en <FaArrowRight />
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Projects;
